import { DataProvider } from '@repo/ui/dataProvider'

import { CurrentTasks } from '@/components/features/CurrentTasks'
import { SkeletonNote } from '@/components/skeletons/SkeletonNote'
import { RootState } from '@/store'
import { Task, useTaskLists } from '@/store/task'

export function BeneficiaryTasksRoute() {
  return (
    <DataProvider
      loadingComponent={<SkeletonNote />}
      selectors={[(state: RootState) => state.task.current]}
      render={(tasks) => <Tasks tasks={tasks} />}
    />
  )
}

function Tasks({ tasks }: { tasks: Task[] }) {
  const { tasksComingSoon, tasksCount, tasksDone, tasksOverdue, tasksWithoutDueDate } =
    useTaskLists(tasks)
  return (
    <CurrentTasks
      tasksComingSoon={tasksComingSoon}
      tasksCount={tasksCount}
      tasksDone={tasksDone}
      tasksOverdue={tasksOverdue}
      tasksWithoutDueDate={tasksWithoutDueDate}
    />
  )
}
